

















































import { Component, Vue, Model } from "vue-property-decorator";

import { TravelTimeSettings } from "@/data/models/SchedulingSettings";

import PickerDialogComponent from "@/components/common/PickerDialog.vue";
import TimePickerComponent from "@/components/common/TimePicker.vue";
import ColorPickerDialogComponent from "@/components/common/ColorPickerDialog.vue";

@Component({
  components: {
    "time-picker": TimePickerComponent,
    "color-picker": ColorPickerDialogComponent,
    picker: PickerDialogComponent,
  },
})
export default class TravelTimeSettingsComponent extends Vue {
  @Model("change")
  travelTimeSettings!: TravelTimeSettings;

  travelTimeCalculationViaMapOptions = [false, true];

  get defaultTravelTimeBetweenTaskAndDepotInMin() {
    return this.travelTimeSettings.defaultTravelTimeBetweenTaskAndDepotInMin;
  }

  set defaultTravelTimeBetweenTaskAndDepotInMin(value: number) {
    this.updateTravelTimeSettings((travelTimeSettings) => {
      travelTimeSettings.defaultTravelTimeBetweenTaskAndDepotInMin = value;
    });
  }

  get defaultTravelTimeBetweenTasksInMin() {
    return this.travelTimeSettings.defaultTravelTimeBetweenTasksInMin;
  }

  set defaultTravelTimeBetweenTasksInMin(value: number) {
    this.updateTravelTimeSettings((travelTimeSettings) => {
      travelTimeSettings.defaultTravelTimeBetweenTasksInMin = value;
    });
  }

  get travelTimeBufferInMin() {
    return this.travelTimeSettings.travelTimeBufferInMin;
  }

  set travelTimeBufferInMin(value: number) {
    this.updateTravelTimeSettings((travelTimeSettings) => {
      travelTimeSettings.travelTimeBufferInMin = value;
    });
  }

  get doTravelTimeCalculationViaMap() {
    return this.travelTimeSettings.doTravelTimeCalculationViaMap;
  }

  set doTravelTimeCalculationViaMap(value: boolean) {
    this.updateTravelTimeSettings((travelTimeSettings) => {
      travelTimeSettings.doTravelTimeCalculationViaMap = value;
    });
  }

  get travelTimeCalculationViaMapFormatter() {
    return (enableCockpit: boolean) => {
      return this.$t(`common.${enableCockpit ? "yes" : "no"}`).toString();
    };
  }

  updateTravelTimeSettings(
    callback: (travelTimeSettings: TravelTimeSettings) => void
  ) {
    const currentValue = this.travelTimeSettings;
    callback(currentValue);

    const update = {
      ...currentValue,
    };

    this.$emit("change", update);
  }
}
